import * as moment from 'moment';
import { Attachment } from '../../shared-components/models/attachment.model';
import { System } from '../../shared-components/System';
import { StudentAttachment } from '../../shared-modules/student-attachment/student-attachment.model';
export class Utility {

    static IsValid(text: any): boolean {
        if (text != null) {
          if (text.length != null) {
            if (text.length > 0) {
              return true;
            }
          }
        }
        return false;
    }

    static addDays(daysToAdd: number): Date  {
        const today = new Date();
        today.setDate(today.getDate() + daysToAdd);
        return today;
    }

    static getAssignmentStatusClass(assignmentStatus: number) {
        switch (assignmentStatus) {
          case 1: {
            return 'assignmentStatusDue';
          }
          case 3: {
            return 'assignmentStatusMissing';
          }
          default: {
            return '';
          }
        }
    }

    static objectiveLevelClass = function (BytLevel) {
        switch (BytLevel) {
            case 2:
                return ('objPaddingLevel2');
            case 3:
                return ('objPaddingLevel3');
            case 4:
                return ('objPaddingLevel4');
            case 5:
                return ('objPaddingLevel5');
            case 6:
                return ('objPaddingLevel6');
            case 7:
                return ('objPaddingLevel7');
            case 8:
                return ('objPaddingLevel8');
            case 9:
                return ('objPaddingLevel9');
            case 10:
                return ('objPaddingLevel10');
            default:
                break;
        }
    };
    static getDateString(value: Date): any {
        return moment(value).format('L');
    }

    static saveFile(attachment:Attachment) {
        if (attachment.DocumentBase64 != null && attachment.DocumentBase64.length > 0) {
        System.saveFile(attachment.DocumentBase64, attachment.DocumentMimeType, attachment.DocumentName);
        }
        else if ((attachment.Id != null && attachment.Id > 0) || (attachment.AttachmentId != null && attachment.AttachmentId > 0)) {
            const studentAttachment: StudentAttachment = {
                DocumentId: (attachment.Id != null && attachment.Id > 0) ? attachment.Id : attachment.AttachmentId,
                DocumentName: attachment.FileName,
                DocumentBase64: attachment.DocumentBase64,
                DocumentMimeType: attachment.DocumentMimeType,
                DocumentModuleName: 'Assignment',
                ReportParameters: [],
                ReportType: 0
              };
        
              window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
              const win = window.open(System.baseUrl + 'studentattachment', '_blank');
              win.focus();
        }
    }
}